import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgWithdrawIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 3h18v4H3zM10 3v4M14 3v4M18 3v4M6 3v4M5 7v13h14V7M12 9v8m0 0-3-3m3 3 3-3"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgWithdrawIcon);
const Memo = memo(ForwardRef);
export default Memo;
